import { toast } from 'react-toastify';
import { deleteBrand } from './deleteBrand';

export const useDeleteBrandData = () => {
  async function submitDeleteBrand(id: number) {
    const res = await deleteBrand(id);
    if (res.type === 'success') {
      toast.success('Successfully deleted brand');
    } else {
      toast.error(res.error.message);
    }

    return res.type;
  }

  return { submitDeleteBrand };
};
